import React from "react";
import "./HamburgerButton.css";

interface HamburgerButtonProps {
  isOpen: boolean;
  onClick: () => void;
  hasNotification?: boolean;
}

const HamburgerButton: React.FC<HamburgerButtonProps> = ({
  isOpen,
  onClick,
  hasNotification = false,
}) => {
  return (
    <button
      className={`hamburger-button ${isOpen ? "open" : ""}`}
      onClick={onClick}
      aria-label="Abrir menu"
    >
      {hasNotification && <span className="notification-badge"></span>}
      <span className="hamburger-line"></span>
      <span className="hamburger-line"></span>
      <span className="hamburger-line"></span>
    </button>
  );
};

export default HamburgerButton;
